<template>
  <SInput
    :placeholder="placeholder"
    :label="label"
    :hint="hint"
    :error="error"
    :disabled="disabled"
    :readonly="true"
    :border="border"
    :icon="'calendar'"
    type="datePicker"
    :value="value"
    @input="input"
    @clear="clear"
    :dateFormat="dateFormat"
    :clearButtonIcon="false"
  />
</template>

<script>
import SInput from "./SInput";
export default {
  name: "SDatePicker",

  components: { SInput },

  data() {
    return {};
  },

  methods: {
    input(val) {
      this.$emit("input", val);
    },
    clear(){
      this.$emit("clear");
    },
  },

  created() {},

  props: {
    value: {},
    placeholder: String,
    label: String,
    hint: String,
    error: String,
    disabled: Boolean,
    readonly: Boolean,
    border: {type:Boolean, default: true},
    dateFormat:{}
  },

  computed: {},
};
</script>

<style lang="scss">
</style>